import React from 'react';
import { FormValue, useField } from 'informed';

import { Country } from '@nw/shared/config';

import { useStateAndDistricts } from '../../hooks/useStateAndDistricts';
import { getCountryDetailsFromCountryId } from '../../utils/ComboBoxUtils';

import {
  CountriesComboBox,
  CountriesComboBoxProps
} from '../CountriesComboBox/CountriesComboBox';

import { FieldContainer } from './styledComponents';

export interface InformedCountriesComboboxProps extends CountriesComboBoxProps {
  isHidden?: boolean;
  field: string;
  validationSchemaObject: any;
  touched: boolean;
  isDisabled?: boolean;
  reRenderObjects?: Array<any>;
  fieldWrapperStyles?: React.CSSProperties;
  initialCountryValue?: string;
  getDisplayValueFromSelectedCountry?: (T: any) => string;
  validateOnChange?: boolean;
  validateOnBlur?: boolean;
  helperText?: string;
  isMarginBottomZero?: boolean;
  hintClassName?: string;
  enableDataMask?: boolean;
  mobilePlaceholder?: string;
}

export const InformedCountriesCombobox = (
  props: InformedCountriesComboboxProps
) => {
  const {
    isHidden,
    field,
    validationSchemaObject,
    fieldWrapperStyles,
    touched,
    onSelectionChange,
    isDisabled,
    label,
    error,
    onBlur: onBlurPropFunc,
    reRenderObjects,
    initialCountryValue,
    getDisplayValueFromSelectedCountry,
    validateOnBlur = true,
    validateOnChange = true,
    helperText,
    isMarginBottomZero,
    hintClassName,
    enableDataMask,
    placeholder,
    ...comboboxProps
  } = props;

  const { fieldState, render, informed } = useField<
    FormValue<{ country_id: string; country_name: string }>
  >({
    field,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validationSchema: validationSchemaObject.fields[field],
    error: error,
    touched: touched,
    isDisabled,
    label,
    ...reRenderObjects
  });

  const { value } = fieldState;
  const { onChange, onBlur } = informed;

  const onBlurFunction = (e) => {
    onBlur(e.target.value);
    onBlurPropFunc && onBlurPropFunc(e.target.value);
  };

  const { countries } = useStateAndDistricts();

  const onSelectionChangeFunc = (value) => {
    const country = getCountryDetailsFromCountryId(value, countries.current);
    onChange(country);
    onSelectionChange && onSelectionChange(country?.country_id);
  };

  const renderCountriesCombobox = () => {
    return (
      <CountriesComboBox
        label={label}
        selectedKey={(value as Country)?.country_id}
        onBlur={onBlurFunction}
        isDisabled={isDisabled}
        placeholder={placeholder}
        onSelectionChange={onSelectionChangeFunc}
        error={error}
        initialCountryValue={initialCountryValue}
        getDisplayValueFromSelectedCountry={getDisplayValueFromSelectedCountry}
        helperText={helperText}
        hintClassName={hintClassName}
        enableDataMask={enableDataMask}
      />
    );
  };

  return render(
    <FieldContainer
      isHidden={isHidden}
      css={fieldWrapperStyles}
      isMarginBottomZero={isMarginBottomZero}
    >
      {renderCountriesCombobox()}
    </FieldContainer>
  );
};
